import { Box } from '@mantine/core';
import { Selection } from 'prosemirror-state';
import { memo, useCallback } from 'react';
import { useSecodaEditor } from '../context';

export const TopGapButton = memo(() => {
	const editorState = useSecodaEditor();

	const handleClick = useCallback(() => {
		if (!editorState.view) {
			return;
		}

		const { state, dispatch } = editorState.view;
		dispatch(state.tr.insert(0, state.schema.nodes.paragraph.create({})));
		dispatch(state.tr.setSelection(Selection.atStart(state.doc)));
		editorState.view.focus();
	}, [editorState.view]);

	return (
		<Box
			onClick={handleClick}
			sx={{
				marginTop: 5,
				marginBottom: 10,
				height: 2,
				width: '100%',
				':before': {
					cursor: 'pointer',
					content: '""',
					display: 'block',
					height: 30,
					marginTop: -15,
					width: '100%',
				},
				':hover': {
					backgroundColor: 'rgba(0,0,0,0.05)',
				},
			}}
		/>
	);
});
